import React, { useEffect } from "react";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../../Components/Layout/PageLayout";
import {
  FormInput,
  FormSelect,
  FormTemplate,
} from "../../../../Components/Forms/InputTemplate";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { FormatDateTime } from "../../../../../../utils/functions/ResourceFunctions";
import { useGetBudgetDetailsByIdQuery } from "../../../../../api";
import { FormatCurrency } from "../../../../../../utils/functions/FormatCurrency";

function BudgetImportDetailsView() {
  const navigate = useNavigate();
  const { id } = useParams();

  const payload = {
    id: id,
  };

  const { data } = useGetBudgetDetailsByIdQuery(payload);
  console.log({ data });

  const formMethods = useForm({
    mode: "all",
  });
  const { handleSubmit } = formMethods;

  const submit = (e) => {
    alert("clicked");
  };

  return (
    <PageLayout title={"Budget Import Details View"} hasBack={true}>
      <FormProvider {...formMethods}>
        <FormTemplate
          className={DashboardStyle.view_app_components}
          handleSubmit={handleSubmit(submit)}
        >
          <section
            style={{
              backgroundColor: "#F8FBF8",
              border: "1px solid #D9E9DA",
              borderRadius: "8px",
            }}
            className={DashboardStyle.form_section}
          >
            <h4 className={DashboardStyle.form_section_title}>
              Budget Information
            </h4>
            <div className={DashboardStyle.labels_group}>
              <div>
                <div>
                  <p>Budget Type:</p>
                  <h4>{data?.responseObject?.budgetType || "N/A"}</h4>
                </div>
                <div>
                  <p>Category:</p>
                  <h4>{data?.responseObject?.category || "N/A"}</h4>
                </div>
                <div>
                  <p>Date Created:</p>
                  <h4>{FormatDateTime(data?.responseObject?.createdDate, "ll") || "N/A"} </h4>
                </div>
              </div>

              <div>
                <div>
                  <p>Item:</p>
                  <h4>{data?.responseObject?.item || "N/A"}</h4>
                </div>
                <div>
                  <p>Unit Price:</p>
                  <h4>
                    {FormatCurrency(data?.responseObject?.unitPrice) || "N/A"}
                  </h4>
                </div>
                <div>
                  <p>Total:</p>
                  <h4>
                    {FormatCurrency(data?.responseObject?.total) || "N/A"}
                  </h4>
                </div>
              </div>

              <div>
                <div>
                  <p>Description:</p>
                  <h4>{data?.responseObject?.description || "N/A"}</h4>
                </div>
                <div>
                  <p>Actual Expenditure:</p>
                  <h4>
                    {FormatCurrency(data?.responseObject?.actualExpenditure) || "N/A"}
                  </h4>
                </div>
                <div>
                  <p>Status:</p>
                  <h4
                    style={{
                      color:
                        data?.responseObject?.approvalStatus === 1
                          ? "#815103"
                          : data?.responseObject?.approvalStatus === 0
                          ? "#0F6308"
                          : data?.responseObject?.approvalStatus === 7
                          ? "#8A002B"
                          : "",
                    }}
                  >
                    {data?.responseObject?.approvalStatus === 1
                      ? "Pending"
                      : data?.responseObject?.approvalStatus === 0
                      ? "Approved"
                      : data?.responseObject?.approvalStatus === 7
                      ? "Cancelled"
                      : "Unknown"}
                  </h4>
                </div>
                <div>
                  <p>Updated Date:</p>
                  <h4>{FormatDateTime(data?.responseObject?.updateDate, "ll") || "N/A"}</h4>
                </div>
              </div>

              <div>
                <div>
                  <p>Quantity:</p>
                  <h4>{data?.responseObject?.quantity || "N/A"}</h4>
                </div>
                <div>
                  <p>Forex:</p>
                  <h4>{data?.responseObject?.forex || "N/A"}</h4>
                </div>
                <div>
                  <p>Budget Owner:</p>
                  <h4>{data?.responseObject?.budgetOwner || "N/A"}</h4>
                </div>
              </div>
            </div>
          </section>
        </FormTemplate>
      </FormProvider>
    </PageLayout>
  );
}

export default BudgetImportDetailsView;
